import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { ConsumerAuthProvider } from './context/ConsumerAuthContext.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConsumerAuthProvider>
        <App />
      </ConsumerAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
